import { render, staticRenderFns } from "./modal-filter-v2.vue?vue&type=template&id=2a1e1a24&scoped=true"
import script from "./modal-filter-v2.vue?vue&type=script&lang=js"
export * from "./modal-filter-v2.vue?vue&type=script&lang=js"
import style0 from "./modal-filter-v2.vue?vue&type=style&index=0&id=2a1e1a24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1e1a24",
  null
  
)

export default component.exports